// NFL Team Logo utilities
// Using ESPN CDN for reliable team logos

const ESPN_LOGO_BASE = "https://a.espncdn.com/i/teamlogos/nfl/500";

// Map team abbreviations to ESPN team names/codes
const TEAM_LOGO_MAP: Record<string, string> = {
  // AFC East
  'BUF': 'buf',
  'MIA': 'mia',
  'NE': 'ne',
  'NYJ': 'nyj',

  // AFC North
  'BAL': 'bal',
  'CIN': 'cin',
  'CLE': 'cle',
  'PIT': 'pit',

  // AFC South
  'HOU': 'hou',
  'IND': 'ind',
  'JAX': 'jax',
  'TEN': 'ten',

  // AFC West
  'DEN': 'den',
  'KC': 'kc',
  'LV': 'lv',
  'LAC': 'lac',

  // NFC East
  'DAL': 'dal',
  'NYG': 'nyg',
  'PHI': 'phi',
  'WAS': 'wsh',

  // NFC North
  'CHI': 'chi',
  'DET': 'det',
  'GB': 'gb',
  'MIN': 'min',

  // NFC South
  'ATL': 'atl',
  'CAR': 'car',
  'NO': 'no',
  'TB': 'tb',

  // NFC West
  'ARI': 'ari',
  'LAR': 'lar',
  'SF': 'sf',
  'SEA': 'sea'
};

/**
 * Get the logo URL for an NFL team
 * @param abbreviation - Team abbreviation (e.g., 'BUF', 'KC')
 * @returns Logo URL string
 */
export function maybeGetTeamLogoUrl(abbreviation?: string | null): string | null {
  if (!abbreviation) {
    return null;
  }

  const espnCode = TEAM_LOGO_MAP[abbreviation.toUpperCase()];
  if (!espnCode) {
    return null;
  }

  return `${ESPN_LOGO_BASE}/${espnCode}.png`;
}

export function getTeamLogoUrl(abbreviation: string): string {
  return maybeGetTeamLogoUrl(abbreviation) ?? '';
}

/**
 * Alternative logo sources for fallback
 */
export const LOGO_FALLBACKS = {
  logocdn: (abbreviation: string) => `https://logocdn.com/nfl/${abbreviation.toLowerCase()}/logo.svg`,
  fantasynerds: (abbreviation: string) => `https://www.fantasynerds.com/images/nfl/${abbreviation.toUpperCase()}.png`,
};
